import { ListQuery, ListResponse } from "../http";
import { OrganizationChange, User } from "../../models";
import { ToJson } from "../../general";
import { adaptDate } from "@gsx/client/common/src/api/adapters";

export interface OrganizationLogListItem {
    createdAt: Date;
    changes: OrganizationChange[];
    user?: Pick<User, "firstName" | "lastName">;
}
export type OrganizationLogListQuery = ListQuery & { query?: string };
export type OrganizationLogListResponse = ListResponse<OrganizationLogListItem[]>;

export const adaptOrganizationLog = <T extends Partial<OrganizationLogListItem>>(
    data: ToJson<T>,
): Partial<OrganizationLogListItem> => ({
    ...data,
    createdAt: adaptDate(data.createdAt),
});
